module.exports = __webpack_public_path__ + "img/second_phone.6fc2e159.png";